import { render, staticRenderFns } from "./DkoTable.vue?vue&type=template&id=4ec4bb90&scoped=true"
import script from "./DkoTable.vue?vue&type=script&lang=js"
export * from "./DkoTable.vue?vue&type=script&lang=js"
import style0 from "./DkoTable.vue?vue&type=style&index=0&id=4ec4bb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec4bb90",
  null
  
)

export default component.exports